<template>
  <div>
    <v-dialog v-model="dialog" max-width="600" persistent scrollable>
      <v-form @submit.prevent="addMeal" ref="form">
        <v-card>
          <v-card-title>Add Meal</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    outlined
                    label="Category"
                    hide-details="auto"
                    :items="type_items"
                    persistent-placeholder
                    v-model="form.category"
                    :error-messages="form.$getError('category')"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    :items="meals"
                    :loading="mealsLoading"
                    item-text="name"
                    item-value="id"
                    label="Meals"
                    multiple
                    chips
                    outlined
                    required
                    class="custom-autocomplete"
                    hide-details="auto"
                    persistent-placeholder
                    v-model="form.meals"
                    :error-messages="form.$getError('meals')"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                        close
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <slot>
              <v-btn @click="closeDialog" text>Cancel</v-btn>
              <v-btn type="submit" color="primary" :loading="form.$busy"
                >Submit</v-btn
              >
            </slot>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text @click="snackbar.show = false" v-bind="attrs">OK</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    week: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      dialog: this.value,
      meals: null,
      mealsLoading: true,
      form: new Form({
        meals: null,
        category: 'breakfast'
      }),
      type_items: [
        { text: 'Breakfast', value: 'breakfast' },
        { text: 'Lunch', value: 'lunch' },
        { text: 'Dinner', value: 'dinner' },
        { text: 'Snack', value: 'snack' }
      ],
      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  created() {
    this.getMealOptions('breakfast')
  },

  methods: {
    ...mapActions({
      addMealPlanWeekAction: 'plan/addMealPlanWeek'
    }),

    addMeal() {
      this.form.$busy = true
      this.form.$clearErrors()
      this.$api
        .post(`plan-weeks/${this.week}/meals`, this.form.$data())
        .then(res => {
          this.$store.commit('plan/setPlanDetails', res.data.data)
          this.closeDialog()
          this.showSnackbar('Meal successfully added!', 'success')
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
        .finally(() => (this.form.$busy = false))
    },

    async getMealOptions(type) {
      this.form.meals = null
      this.$api
        .get(`meals?limit=999999&filter[status]=active&filter[type]=${type}`)
        .then(res => {
          this.meals = res.data.data
        })
        .finally(() => (this.mealsLoading = false))
    },

    closeDialog() {
      this.dialog = false
      this.form.meals = null
      this.form.category = 'breakfast'
      this.form.$clearErrors()
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  },

  watch: {
    dialog(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.dialog = val
    },
    'form.category': function(val) {
      this.getMealOptions(val)
    }
  }
}
</script>

<style>
.custom-autocomplete .v-select__selections {
  min-height: 0 !important;
}
</style>
